import { log } from '@/services/logService'
import userService from '@/services/userService'
import authService from '@/services/authService'
import deliveryService from '@/services/deliveryService'
import router from '@/router'

let initializedResolve
let initialized = new Promise((resolve, reject) => {
  initializedResolve = resolve
})
let cordova = null
let registrationToken = null

function onDeviceReady () {
  cordova.on('pause', onPause, false)
  cordova.on('resume', onResume, false)
  if (cordova.device.platform === 'Android') {
    document.addEventListener('backbutton', onBackKeyDown, false)
  }
  registerNotificationsHandlers()
  if (authService.isAuthenticated()) {
    onLogin()
  }
  localNotifications()
  initializedResolve()
}

function onPause () {
  // Handle the pause lifecycle event.
  log('onPause')
}

function onResume () {
  // Handle the resume lifecycle event.
  // SetTimeout required for iOS.
  setTimeout(() => {
    deliveryService.getDeliveries()
    log('onResume')
  }, 0)
}

function onBackKeyDown () {
  if (router.currentRoute.path === '/') {
    navigator.app.exitApp()
  } else {
    router.back()
  }
}

function registerNotificationsHandlers () {
  window.FirebasePlugin.onNotificationOpen((notification) => {
    log('new notification:', notification)

    // new-delivery, delivery-update
    let action = notification.action
    let type = notification.type
    // true = app opened via notification, false = notification arrived while app was in foreground
    let tap = notification.tap
    let deliveryId = +notification.deliveryId

    if ((action === 'new-delivery' || action === 'delivery-update') && tap) {
      log('tap on notification, redirecting to /delivery/' + notification.deliveryId)
      try {
        router.push('/delivery/' + notification.deliveryId)
      } catch (error) {
        log('couldn\'t push route', error)
      }
    }
    if ((action === 'new-delivery' || action === 'delivery-update') && !tap) {
      // reload delivery in the backgroud; TODO: signal to the user
      deliveryService.getDelivery(deliveryId)
      if (type === 'comment') {
        deliveryService.getDeliveryComments(deliveryId)
      }
    }
    if (action === 'balance-update' && tap) {
      router.push('/balance')
    }
  }, function (error) {
    log('Error onNotificationOpen', error)
  })
}

function onLogin () {
  initialized.then(() => {
    getRegistrationToken()
    subscribeToTopics()
  })
}

function getRegistrationToken () {
  window.FirebasePlugin.onTokenRefresh((token) => {
    registrationToken = token
    // save this server-side and use it to push notifications to this device
    if (authService.isAuthenticated()) {
      userService.updateAndroidRegistration(registrationToken)
    }
  }, (error) => {
    log('Error getting Android registration token', error)
  })
}

function subscribeToTopics () {
  initialized.then(() => {
    window.FirebasePlugin.subscribe('deliveries2')
    userService.getUser().then(user => window.FirebasePlugin.subscribe(`deliveries-${user.region_id}`))
  })
}

function unsubscribeToTopics () {
  initialized.then(() => {
    window.FirebasePlugin.unsubscribe('deliveries2')
  })
}

function localNotifications () {
  if (window.cordova.plugins && window.cordova.plugins.notification && window.cordova.plugins.notification.local) {
    // window.cordova.plugins.notification.local.schedule({
    //   title: 'My first notification',
    //   text: 'Thats pretty easy...',
    //   foreground: true
    // })
    // log('Local notifications defaults:', window.cordova.plugins.notification.local.getDefaults())
    // log('Launch details', window.cordova.plugins.notification.local.launchDetails)
  } else {
    // log('no local notifications', cordova.plugins)
    // log('window.cordova.plugins', window.cordova.plugins)
  }
}

export default {
  initialize: function (appContext) {
    log('initialize')
    cordova = appContext.cordova
    // following event happens in hybrid app and not in browser
    cordova.on('deviceready', onDeviceReady)
  },
  onLogin,
  subscribeToTopics,
  unsubscribeToTopics
}
